"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReplaceCarStartDateWarningWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var core_1 = require("@athena-portal/core");
var services_1 = require("@falcon/services");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var moment = require("moment");
var ReplaceCarStartDateWarningWidget = /** @class */ (function (_super) {
    __extends(ReplaceCarStartDateWarningWidget, _super);
    function ReplaceCarStartDateWarningWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.findPreviousPolicyInteraction = function () {
            var previousPolicies = [];
            if (_this.state.policies && _this.state.policies.length > 0) {
                _this.state.policies.forEach(function (policy) {
                    if (policy.status !== "MTC" && policy.interaction.vehicles && policy.policyNumber === _this.props.interaction.agreementNumber) {
                        previousPolicies.push(policy);
                    }
                });
            }
            return previousPolicies.length > 0 ? previousPolicies.slice(-1)[0].interaction : undefined;
        };
        _this.state = {
            policies: [],
            carFullDescription: "",
        };
        return _this;
    }
    ReplaceCarStartDateWarningWidget.prototype.componentDidMount = function () {
        var _this = this;
        this.customerPortalService.getPolicyHistory().subscribe(function (policies) {
            _this.setState({ policies: policies });
        });
    };
    ReplaceCarStartDateWarningWidget.prototype.render = function () {
        var previousInteraction = this.findPreviousPolicyInteraction();
        var vehicleMake = "";
        var vehicleModel = "";
        var vehicleRegistrationNumber = "";
        var newStartDate = "";
        if (previousInteraction) {
            vehicleMake = previousInteraction.vehicles[0].make;
            vehicleModel = previousInteraction.vehicles[0].model;
            vehicleRegistrationNumber = previousInteraction.vehicles[0].registrationNumber;
            newStartDate = moment(this.props.interaction.headerInfo.startDate).format("DD MMM YYYY").toString() + ", 23:59";
        }
        return ((0, jsx_runtime_1.jsxs)("div", { className: "info-button-panel d-flex banner", children: [(0, jsx_runtime_1.jsx)("img", { className: "d-block m-0", src: "/".concat(services_1.resourcesHelper.THEME, "/img/alert-grey-blue.svg"), alt: "warning-sign" }), (0, jsx_runtime_1.jsxs)("div", { children: ["The current cover for ", "".concat(vehicleMake, ", ").concat(vehicleModel, " (").concat(vehicleRegistrationNumber, ") WILL END on ").concat(newStartDate)] })] }));
    };
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.CustomerPortalService),
        __metadata("design:type", Object)
    ], ReplaceCarStartDateWarningWidget.prototype, "customerPortalService", void 0);
    return ReplaceCarStartDateWarningWidget;
}(plugin_journey_1.WidgetBase));
exports.ReplaceCarStartDateWarningWidget = ReplaceCarStartDateWarningWidget;
//# sourceMappingURL=ReplaceCarStartDateWarningWidget.js.map